import styled, { css } from 'styled-components';

export const Container = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
`;

interface ITextInput {
  hasIcon?: boolean;
  status?: 'none' | 'success' | 'error';
}

export const TextInput = styled.input<ITextInput>`
  border-radius: 4px;
  color: #000;
  padding: ${({ hasIcon }) => (hasIcon ? '8px 38px 8px 12px' : '8px 12px')};
  box-shadow: 0px 1px 4px 0px #00000029;
  width: 100%;
  font-size: 14px;

  &:placeholder-shown {
    box-shadow: none;
    border: 1px solid #d0dae3;
  }

  ${({ status }) =>
    status === 'error'
      ? css`
          border: 1px solid #ff5656;
        `
      : css`
          border: 1px solid #fff;
        `}
`;

export const Icon = styled.img`
  position: absolute;
  right: 12px;
`;
